<template>
	<sf-modal-layout class="qms-pop1" :title="getMessage_('QWCC000974')" :show="show" :closeModal="close">
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 h-100 card_bg">
				<div class="sf-search-layout__body__container">
					<sf-search-layout>
						<el-row :gutter="20">
							<!-- 검사기간 -->
							<el-col :span="6">
								<div class="sf-input-group-wrapper">
									<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001224') }}</span>
									<el-date-picker
										v-model="searchDateRange"
										type="daterange"
										align="right"
										:start-placeholder="getMessage_('QWCC000920')"
										:end-placeholder="getMessage_('QWCC000954')"
										range-separator="~"
									/>
								</div>
							</el-col>
							<!-- 작성자 -->
							<el-col :span="4">
								<search-input
									:label="getMessage_('QWCC001382')"
									paramKey="pprrId"
									@commInput="onChangeData"
									:clearable="false"
									:propData="pprrNm"
								>
									<template v-slot:icon> <i class="icon-sf-search search-icon" @click="() => onUserPopup('pprr')"></i></template>
								</search-input>
							</el-col>
							<el-col :span="4">
								<search-input
									:label="getMessage_('QWCC001936')"
									paramKey="pmcNo1"
									@commInput="onChangeData"
									:propData="pmcNo1"
								></search-input>
							</el-col>
						</el-row>
						<template slot="button">
							<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
								{{ getButtonMsg_(scrId, 'CR') }}
							</sf-button>
						</template>
					</sf-search-layout>
				</div>
			</sf-card>
		</div>
		<div class="sf-col sf-col-10">
			<sf-card class="p-0 border-0 bg-transparent h-100">
				<sf-data-table
					ref="popupTable"
					:pageUnit="pmcPagingInfo.pageUnit"
					:totalSize="pmcPagingInfo.totalSize"
					paging
					:columns="columns"
					:rows="pmcList"
					height="60vh"
					fit="fit"
					:stripe="false"
					:excel="isButton_(scrId, 'EX')"
					@changedPage="changedPage"
				>
				</sf-data-table>
			</sf-card>
		</div>
		<user-popup-view ref="userPopupView" @SendData="sendData" :scrId="scrId" />
	</sf-modal-layout>
</template>

<script>
import _ from 'lodash';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/fcku/FwdCkuTest/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import UserPopupView from '@qms/comm/commpopup/UserPopup/UserPopupView.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchInput, UserPopupView },
	data() {
		return {
			show: false,
			pprrId: '',
			pprrNm: '',
			pmcNo1:'',
			searchDateRange: [this.$moment().startOf('month').format('YYYY-MM-DD'), this.$moment().endOf('month').format('YYYY-MM-DD')]
		};
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async open() {
			this.show = true;
			await this.searchList();
		},
		close() {
			this.refresh();
			this.show = false;
		},
		refresh() {
			this.show = false;
			this.pprrId = '';
			this.searchDateRange = [this.$moment().startOf('month').format('YYYY-MM-DD'), this.$moment().endOf('month').format('YYYY-MM-DD')];
			this.$emit('Refresh');
		},
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				let strDt, endDt;
				if (this.searchDateRange) {
					strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
					endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				} else {
					strDt = '';
					endDt = '';
				}
				await this.getPmcList_({ strDt, endDt, pprrId: this.pprrId,pmcNo1:this.pmcNo1 });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		clickEvent(row) {
			this.$emit('sendPmc', row);
			this.close();
		},
		onChangeData({ key, value }) {
			this[key] = value;
		},
		onUserPopup(userGbn) {
			this.$refs.userPopupView.open({ userGbn, userName: this[userGbn + 'Nm'] });
		},
		sendData(userData, userGbn) {
			this.onChangeData({ key: userGbn + 'Id', value: userData.userId });
			this.onChangeData({ key: userGbn + 'Nm', value: userData.userName });
		},
		onUserInPutKeyDown(userGbn) {
			this.onChangeData({ key: userGbn + 'Id', value: '' });
		},
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPmcPagingInfo_({ key: 'currentPage', value: currentPageVal, info: 'pmcPagingInfo' });
			this.setPmcPagingInfo_({ key: 'pageUnit', value: pageUnitVal, info: 'pmcPagingInfo' });
			await this.searchList();
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001721'), //PMC no.
					prop: 'pmcNo',
					minWidth: '130px',
					clickEvent: this.clickEvent,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001379'), //차수
					prop: 'ipnNos',
					minWidth: '70px'
				},
				{
					label: this.getMessage_('QWCC000973'), //기종
					prop: 'tymaCd',
					minWidth: '1px',
					form: {
						type: 'select',
						options: this.tymaCdList,
						placeholder: ' ',
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC001452'), //고객사
					prop: 'custNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001722'), //생산일
					prop: 'prdtDd',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001983'), //검사일자
					prop: 'pprrDt',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001977'), //MES 검사시작
					prop: 'ckuStrtDt',
					minWidth: '150px'
				},
				{
					label: this.getMessage_('QWCC001978'), // MES 종료일자
					prop: 'ckuEndDt',
					minWidth: '150px'
				},

				{
					label: this.getMessage_('QWCC001382'), //작성자
					prop: 'pprrNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001222'), //판정결과
					prop: 'jgmtRsltCd',
					minWidth: '80px',
					form: {
						type: 'select',
						options: this.indvJgmtCdList,
						placeholder: ' ',
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC000906'), //출력상태
					prop: 'oputStCd',
					minWidth: '90px',
					form: {
						type: 'select',
						options: this.oputStCdList,
						placeholder: ' ',
						isDisabled: () => true
					}
				}
			];
		}
	}
};
</script>

<style lang="scss" scoped>
.sf-button.sf-line-default {
	min-width: fit-content;
}
</style>
